import { useIntl } from '@zenbusiness/application-commons-intl';

import { useDashboardPath } from '#client/hooks/useDashboardPath';
import { routesName } from '#client/pages/ProductLanding/constants/routes';
import { DEFAULT_CATEGORY_FILTER, PRODUCTS_FILTER_PARAM_KEY } from '#client/pages/Products/constants';

export const useProductsBreadcrumbs = (productId) => {
  const dashboardPath = useDashboardPath();
  const { formatMessage: fm } = useIntl();
  const categorySlug = localStorage.getItem(PRODUCTS_FILTER_PARAM_KEY);

  const breadcrumbs = [
    {
      label: fm({ id: 'route.dashboard.label' }),
      to: dashboardPath
    }
  ];

  if (productId) {
    const productsPageCrumb = {
      label: fm({ id: 'route.products.shortenedLabel' })
    };

    const searchParams = categorySlug && categorySlug !== DEFAULT_CATEGORY_FILTER
      ? `?${PRODUCTS_FILTER_PARAM_KEY}=${categorySlug}`
      : '';

    productsPageCrumb.to = `${dashboardPath}/products${searchParams}`;

    breadcrumbs.push(productsPageCrumb);
    breadcrumbs.push({ label: routesName[productId] });
  } else breadcrumbs.push({ label: fm({ id: 'route.products.label' }) });

  return breadcrumbs;
};
